import AuthOutlet from "@auth-kit/react-router/AuthOutlet";
import { Outlet, Route, Routes } from "react-router-dom";
import { Fragment } from "react/jsx-runtime";
import PageLoader from "./components/page-loader";
import useProfile from "./hooks/use-profile";
import NotFound from "./page/404";
import { privateRoutes } from "./routes/privateRoutes";
import { publicRoutes } from "./routes/publicRoutes";
import AgentDashboardTopBar from "./app/shared/agent-dashboard-top-bar";
import { TopBarHeightProvider } from "./app/shared/agent-dashboard-top-bar/top-bar-height-context";
import { useAutoSubscribe } from "./hooks/useAutoSubscribe";

function App() {
  const { profile, loading } = useProfile();

  return (
    <PageLoader loading={loading}>
      <Routes>
        {publicRoutes.length > 0 &&
          publicRoutes.map((route, index) => {
            const Layout = route.layout ?? Fragment;
            const Page = route.component;
            return (
              <Route
                key={route?.path || index}
                path={route.path}
                element={
                  <Layout>
                    <Page />
                  </Layout>
                }
              />
            );
          })}
        <Route element={<AuthOutlet fallbackPath="/sign-in" />}>
          <Route element={<PrivateRoute />}>
            {privateRoutes.length > 0 &&
              privateRoutes.map((route, index) => {
                if (
                  route.permissions &&
                  route.permissions.length > 0 &&
                  !!profile
                ) {
                  const currentRole = profile.role;

                  if (!route.permissions.includes(currentRole)) {
                    return; // Or navigate to 403 page
                  }
                }
                const Layout = route.layout ?? Fragment;

                const Page = route.component;

                return (
                  <Route
                    key={route?.path || index}
                    path={route.path}
                    element={
                      <Layout>
                        <Page />
                      </Layout>
                    }
                  />
                );
              })}
          </Route>
        </Route>
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </PageLoader>
  );
}

const PrivateRoute = () => {
  useAutoSubscribe();

  return (
    <TopBarHeightProvider>
      <AgentDashboardTopBar className="px-4 xl:px-0" />
      <Outlet />;
    </TopBarHeightProvider>
  );
};

export default App;
